import { ref } from 'vue'

/** 정보마당 보기 테마: 라이트(아이보리) / 다크(에디토리얼) */
export type InfoTheme = 'light' | 'dark'

const STORAGE_KEY = 'infoPlazaTheme'

function loadTheme(): InfoTheme {
  if (typeof localStorage === 'undefined') return 'light'
  return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light'
}

/* 두 페이지(목록·상세)가 같은 상태를 보도록 모듈 스코프에 둔다 */
const theme = ref<InfoTheme>(loadTheme())

export function useInfoTheme() {
  const setTheme = (next: InfoTheme) => {
    theme.value = next
    try {
      localStorage.setItem(STORAGE_KEY, next)
    } catch {
      /* 저장 불가 환경이면 무시 */
    }
  }

  const toggleTheme = () => setTheme(theme.value === 'dark' ? 'light' : 'dark')

  return { theme, setTheme, toggleTheme }
}
